module.exports = __webpack_public_path__ + "img/textura-elvas-2@3x.06097b99.png";